import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const propTypes = {
  children: PropTypes.node.isRequired,
  narrow: PropTypes.bool,
  type: PropTypes.oneOf(['default', 'success']),
  vertical: PropTypes.bool,
};

const defaultProps = {
  narrow: false,
  vertical: true,
};

const TabHeader = ({ children, ...props }) => (
  <HeaderWrap {...props}>
    <HeaderLabel {...props}>{children}</HeaderLabel>
  </HeaderWrap>
);
TabHeader.propTypes = propTypes;
TabHeader.defaultProps = defaultProps;

const HeaderWrap = styled.div`
  border-radius: 6px 6px 0px 0px;
  box-shadow: ${
    props => props.vertical
      ? `0 1px 25px 3px ${props.theme['grey-normal']}`
      : 'none'
    };
  margin: 0px 35px 0px 0px;
  position: relative;
  width: ${
    props => props.vertical
      ? '100%'
      : 'auto'
    };

  @media (min-width: 1101px) {
    border-radius: ${
      props => props.vertical
        ? '0px 0px 0px 6px'
        : '6px 0px 0px 0px'
      };
    left: 0;
    position: ${
      props => props.vertical
        ? 'absolute'
        : 'relative'
      };
    top: 0;
    transform: ${
      props => props.vertical
        ? 'rotate(90deg)'
        : 'none'
      };
    transform-origin: 0px top 0px;
    width: auto;

    &::before {
      background-color: ${
        props => props.vertical
          ? '#ffffff'
          : props.theme['green-normal']
        };
      border-radius: ${
        props => props.vertical
          ? '0px 0px 6px 0px'
          : '0px 6px 0px 0px'
        };
      bottom: 0;
      box-shadow: ${
        props => props.vertical
          ? `0 1px 25px 3px ${props.theme['grey-normal']}`
          : 'none'
        };
      content: '';
      position: absolute;
      right: -6px;
      top: 0;
      transform: ${
        props => props.vertical
          ? 'skew(-22.5deg)'
          : 'skew(22.5deg)'
        };
      transform-origin: ${
        props => props.vertical
          ? 'right bottom'
          : 'right top'
        };
      width: 100%;
    }
  }

  @media print {
    position: static;
    border-radius: 0;
    margin: 0px 45px 0px 0px;
    padding: ${
      props => props.narrow
        ? '10px 40px'
        : '20px 40px'
      };
    left: 0px;
    transform: unset;
    transform-origin: unset;
    color: white;
    font-size: 14px;
    z-index: 1000;
  }
`;

const HeaderLabel = styled.div`
  background-color: ${
    props => props.vertical
      ? '#ffffff'
      : props.theme['green-normal']
    };
  color: ${
    props => props.vertical
      ? props.theme['text-black']
      : props.theme['text-white']
    };
  font-weight: bold;
  padding: ${
    props => props.narrow
      ? '10px 40px'
      : '20px 40px'
    };
  position: relative;

  @media (min-width: 720px) {
    border-radius: 6px 6px 0px 0px;
  }

  @media (min-width: 1101px) {
    border-radius: ${
      props => props.vertical
        ? '0px 6px 0px 0px'
        : '6px 0px 0px 0px'
      };
    transform: ${
      props => props.vertical
        ? 'scaleY(-1) scaleX(-1)'
        : 'none'
      };
  }
`;

export default TabHeader;
